import React, { Component } from "react";
import * as actions from "../../store/actions/index";
import { connect } from "react-redux";
import { apiService } from '../../common/apiCallService';
import { generateCardLinks, saveActivity, updateOnBoard } from '../../common/commonService';
import HandReplayer from "../HandReplayer/HandReplayer.js";
import ReplayHand from "../HandReplayer/ReplayHand.js";
import config from '../../common/config.js';
class MultipleReplayerPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openMultiHandRep: false,
            currentReplayerHandIndex: 0,
            displayContent: true,
            selectedHandList: []
        };
    }

    componentDidMount = () => {

        this.setState({
            selectedHandList: JSON.parse(localStorage.getItem("selectedHandList"))
          },()=>{
            localStorage.setItem('fromClient',true);
            localStorage.removeItem("selectedHandList");
            this.props.setSelectedHandList(this.state.selectedHandList);
          });
    }

    setStarFlagOfHnad = (hand, newStarValue) => {
        let reqObj = {
            staredHand: newStarValue,
            accountName: localStorage.getItem("accountName"),
            gameType: hand.gameType,
            gameNo: hand.gameNo,
            time: hand.time
        }
        apiService(config.baseUrl + '/handInfo/setStarFlagOfHandInfo', reqObj, (data) => {
            this.setState({ displayContent: false }, () => {
                this.setState({ loading: false ,displayContent: true})
                saveActivity({
                    hit_page: 'MyHands',
                    hit_type: 'FavouriteHand',
                    hit_attribute1: hand.gameType,
                    hit_attribute2: newStarValue,
                    hit_attribute3: hand.gameNo,
                    hit_attribute4: hand.time
                })
            })
        }, (error) => {
            console.log("Error", error)
            this.setState({ loading: false })
        })
    }

    setLocalHandListStarValue = (hand, newStarValue) => {
        let newSelectedHandList = this.props.selectedHandList;
        newSelectedHandList.map(handObj => {
            console.log(handObj.gameNo, "===", hand.gameNo, "res:", handObj.gameNo === hand.gameNo)
            if (handObj.gameNo === hand.gameNo && hand.time === handObj.time) {
                handObj.staredHand = newStarValue;
            }
            return handObj;
        })
        this.setState({ displayContent: false }, () => {
            this.props.setSelectedHandList(newSelectedHandList)
            this.setState({displayContent:true});
        })
    }

    prevHand = () => {
        if (this.state.currentReplayerHandIndex > 0) {
            this.setState({ displayContent: false }, () => {
                this.setState({ currentReplayerHandIndex: this.state.currentReplayerHandIndex - 1,displayContent:true})
            })
        }
    }
    nextHand = () => {
        if (this.state.currentReplayerHandIndex < this.props.selectedHandList.length - 1) {
            this.setState({ displayContent: false }, () => {
                this.setState({ currentReplayerHandIndex: this.state.currentReplayerHandIndex + 1,displayContent:true})
            })
        }
    }
    openThisHand = (currentReplayerHandIndex) => {
        this.setState({ displayContent: false }, () => {
            this.setState({ currentReplayerHandIndex,displayContent:true })
        })
    }

    render() {
        let nav = typeof navigator !== "undefined" ? navigator : null;
    let fullVersion = 0;
    if (nav) {
      if (nav.appVersion.includes("Mac")) {
        if (nav.appVersion.includes("Mobile")) {
          let osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nav.appVersion);
          fullVersion = parseFloat(
            osVersion[1] + "." + osVersion[2] + osVersion[3]
          );
          if (fullVersion > 12.1) {
            fullVersion = 13;
          } else {
            fullVersion = 12;
          }
        } else {
          let osVersion = /OS X (\d+)_(\d+)_?(\d+)?/.exec(nav.appVersion);
          if(osVersion !=null) {
            fullVersion = parseFloat(osVersion[1] + "." + osVersion[2]);
            if (fullVersion > 10.13) {
              fullVersion = 13;
            } else {
              fullVersion = 12;
            }
          }
          else {
            fullVersion = 13;
          }
        }
      } else {
        fullVersion = 13;
      }
    }
        return (
            <div>
                <style>{"\
        html{\
            width:100% !important;\
          }\
          body{\
            height:100vh !important;\
          }\
      "}</style>
                { this.props.selectedHandList && this.state.displayContent && this.props.selectedHandList.length > 0 ? <div style={{
                    top: 0,
                    left: 0,
                    zIndex: 20000,
                    width: "100%",
                    height: "100%",
                    overflow: "auto",
                    position: "fixed",
                    backgroundColor: '#2c2c34'
                }}>
                    <style>{"\
                        .navbar-fixed-top{\
                        z-index:0 !important;\
                        }\
                    "}</style>
                    {fullVersion && parseFloat(fullVersion) < 13 ? <HandReplayer
                        replayerScreen={'desktop'}
                        isMultipleHands={true}
                        selectedHandCount={this.props.selectedHandList.length}
                        currentReplayerHandIndex={this.state.currentReplayerHandIndex}
                        prevHand={this.prevHand}
                        nextHand={this.nextHand}
                        gameTypeForTitle={this.props.selectedHandList[this.state.currentReplayerHandIndex].gameType}
                        onClose={() => window.close()}
                        loginStatus={true}
                        gameNo={this.props.selectedHandList[this.state.currentReplayerHandIndex].gameNo}
                        accountName={localStorage.getItem('accountName')}
                        partitionDate={this.props.selectedHandList[this.state.currentReplayerHandIndex].fullDateTime}
                    /> :
                        <ReplayHand
                            replayerScreen={'desktop'}
                            isMultipleHands={true}
                            selectedHandList={this.props.selectedHandList}
                            selectedHandCount={this.props.selectedHandList.length}
                            currentReplayerHandIndex={this.state.currentReplayerHandIndex}
                            prevHand={this.prevHand}
                            nextHand={this.nextHand}
                            openThisHand={this.openThisHand}
                            setStarFlagOfHnad={(hand, newStarValue) => {
                                this.setStarFlagOfHnad(hand, newStarValue);
                                this.setLocalHandListStarValue(hand, newStarValue);
                            }}
                            loginStatus={true}
                            gameNo={this.props.selectedHandList[this.state.currentReplayerHandIndex].gameNo}
                            partitionDate={this.props.selectedHandList[this.state.currentReplayerHandIndex].fullDateTime}
                            accountName={localStorage.getItem('accountName')}
                            gameTypeForTitle={this.props.selectedHandList[this.state.currentReplayerHandIndex].gameType}
                            onClose={() => window.close()}
                        />}
                </div> : null}

                
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        selectedHandList: state.handHistory.selectedHandList,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setSelectedHandList: (data) => dispatch(actions.setSelectedHandList(data)),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(MultipleReplayerPopup);






/** WEBPACK FOOTER **
 ** ./src/components/HandReplayer/MultipleReplayerPopup.js
 **/